import { useEffect, useState } from 'react';

/**
 * Hook to listen for `mfe:ready` events and track when a given MFE's CSS is loaded.
 *
 * @param {string} mfeName - The name of the microfrontend (e.g., "ispm-ui").
 * @returns {boolean} - True if the MFE is reported ready with CSS loaded, false otherwise.
 */
const useMfeReady = (mfeName) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const handleMfeReady = (event) => {
      if (event.detail?.mfeName === mfeName) {
        setIsReady(!!event.detail?.cssLoaded);
      }
    };

    window.addEventListener('mfe:ready', handleMfeReady);

    return () => {
      window.removeEventListener('mfe:ready', handleMfeReady);
    };
  }, [mfeName]);

  return isReady;
};

export default useMfeReady;
